var map = {
	"./danger-logo.svg": "35c4",
	"./door-left-logo.svg": "7758",
	"./ekool-logo.svg": "a76e",
	"./eliis-logo.svg": "695c",
	"./google-logo.svg": "7212",
	"./letter-logo.svg": "bcad",
	"./lock-locked-logo.svg": "bb6e",
	"./microsoft-logo.svg": "771b",
	"./passkey-logo.svg": "0035",
	"./phone-logo.svg": "18dd",
	"./protected-logo.svg": "7057",
	"./sms-logo.svg": "880b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17db";